<template>
  <blank-container
    :title="$route.meta.title[$i18n.locale]"
    @addBtn="$router.push({ name: 'googleforms-create' })"
  >
    <a-row class="content-fix">
      <a-table
        :scroll="{ x: 1500, y: 600 }"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-key="(rec) => rec.id"
      >
        <div
          v-if="item"
          slot="googleforms_title"
          slot-scope="item"
          class="td-post-item"
          @click="
            $router.push(
              { name: 'googleforms-detail', params: { id: item.id } },
              () => null
            )
          "
        >
          <b>{{ getFirstFulfilled(item.title).text }}</b>
          <br />
          <a-tag v-if="item && item.title">
            <img
              width="14"
              class="flag-svg__tab"
              :src="
                contentLanguages[getFirstFulfilled(item.title).lang].flagSrc
              "
              :alt="getFirstFulfilled(item.title).lang"
            />
            {{ contentLanguages[getFirstFulfilled(item.title).lang].abr }}
          </a-tag>
        </div>

        <template v-if="item" slot="id" slot-scope="item">
          <b>{{ item.id }}</b>
        </template>
        <template v-if="item" slot="position" slot-scope="item">
          <b>{{ item.position }}</b>
        </template>
        <template
          v-if="item && item.title"
          slot="title_languages"
          slot-scope="item"
        >
          <template v-for="(title, key) in item.title">
            <a-tag v-if="title" :key="key">
              <img
                width="14"
                class="flag-svg__tab"
                :src="contentLanguages[key].flagSrc"
                :alt="key"
              />
              {{ contentLanguages[key].abr }}
            </a-tag>
          </template>
        </template>
        <template v-if="item" slot="content_languages" slot-scope="item">
          <template v-if="item.link">
            <template
              v-for="(link, key) in JSON.parse(JSON.stringify(item.link))"
            >
              <a-tag v-if="link" :key="key">
                <img
                  width="14"
                  class="flag-svg__tab"
                  :src="contentLanguages[key].flagSrc"
                  :alt="key"
                />
                {{ contentLanguages[key].abr }}
              </a-tag>
            </template>
          </template>
        </template>
        <template v-if="item" slot="created" slot-scope="item">
          {{ moment(item).format("LLL") }}
        </template>
        <template v-if="item" slot="updated" slot-scope="item">
          {{ moment(item).format("LLL") }}
        </template>
        <template v-if="item" slot="slug" slot-scope="item">
          {{ item.slug }}
        </template>
        <template v-if="item" slot="language_support" slot-scope="item">
          <template v-for="(languageSupport, key) in item.language_support">
            <a-tag v-if="languageSupport" :key="key">
              <img
                width="14"
                class="flag-svg__tab"
                :src="contentLanguages[key].flagSrc"
                :alt="key"
              />
              {{ contentLanguages[key].abr }}
            </a-tag>
          </template>
        </template>
        <template v-if="item" slot="status" slot-scope="item">
          <!-- <osg-image :img="item" /> -->
          <a-tag :color="item.status ? 'geekblue' : 'volcano'">
            {{ item.status ? "Опубликован" : "Не опубликован" }}
          </a-tag>
        </template>
        <template v-if="item && item.is_main" slot="is_main" slot-scope="item">
          <a-tag :color="item.is_main ? 'geekblue' : 'volcano'">
            {{ item.is_main ? "Вкл." : "Выкл." }}
          </a-tag>
        </template>
        <template
          v-if="item && item.to_slider"
          slot="to_slider"
          slot-scope="item"
        >
          <a-badge
            :status="item.is_slider ? 'success' : 'error'"
            :text="item.is_slider ? 'Да' : 'Нет'"
          />
        </template>
        <template v-if="item && item.files" slot="files_num" slot-scope="item">
          {{ Object.keys(item.files).length }}
        </template>
        <template v-if="item && item.views" slot="views" slot-scope="item">
          <a-icon type="eye" />
          {{ item.views }}
        </template>
        <template v-if="item && item.files" slot="files_size" slot-scope="item">
          {{
            bytesToSize(
              Object.values(item.files).reduce((a, b) => a + b.size, 0)
            )
          }}
        </template>
        <template v-if="item" slot="operation" slot-scope="item">
          <a-icon
            class="action-btns"
            type="edit"
            @click="
              $router.push(
                { name: 'googleforms-detail', params: { id: item.id } },
                () => null
              )
            "
          />
          <a-popconfirm
            cancel-text="Нет"
            ok-text="Да"
            title="Вы действительно хотите удалить?"
            @confirm="removeItem(item)"
          >
            <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
          </a-popconfirm>
        </template>
      </a-table>
    </a-row>
    <a-row v-if="count" class="mt-1">
      <a-pagination :current="page" :total="count" @change="toPage" />
    </a-row>
  </blank-container>
</template>

<script>
// import osgImage from "@/components/image/osgImage/osgImage"
import { CONTENT_LANGUAGES } from "@/constants"
import { mapState, mapMutations, mapActions } from "vuex"
const columns = [
  {
    title: "ID",
    key: "id",
    width: 50,
    scopedSlots: { customRender: "id" }
  },
  {
    title: "Заголовок",
    width: 150,
    key: "googleforms_title",
    scopedSlots: { customRender: "googleforms_title" }
  },
  {
    title: "Языки заголовков",
    key: "title_languages",
    width: 150,
    scopedSlots: { customRender: "title_languages" }
  },
  {
    title: "Языки форм опросов",
    key: "content_languages",
    width: 150,
    scopedSlots: { customRender: "content_languages" }
  },
  {
    title: "Доступность языков",
    key: "language_support",
    width: 150,
    scopedSlots: { customRender: "language_support" }
  },
  // {
  //     title: "Cтатус",
  //     width: 100,
  //     key: "status",
  //     scopedSlots: { customRender: "status" }
  // },
  {
    title: "Обновлено",
    dataIndex: "updated",
    key: "updated",
    width: 150,
    scopedSlots: { customRender: "updated" }
  },
  {
    title: "Создано",
    dataIndex: "created",
    key: "created",
    width: 150,
    scopedSlots: { customRender: "created" }
  },
  {
    title: "Действие",
    key: "operation",
    fixed: "right",
    scopedSlots: { customRender: "operation" },
    width: 90
  }
]

export default {
  // components: {
  //   osgImage
  // },
  data: () => ({
    loading: false,
    columns
  }),

  computed: {
    ...mapState("googleforms", {
      list: (state) => state.list,
      count: (state) => state.count
    }),
    page() {
      return +this.$route.query.page || 1
    },
    perPage() {
      return +this.$route.query.per_page || 10
    },
    contentLanguages: () => CONTENT_LANGUAGES
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  methods: {
    ...mapMutations({
      removeItem: "googleforms/removeListItem"
    }),
    ...mapActions({
      fetch: "googleforms/fetch",
      deleteItemAction: "googleforms/deleteItemAction"
    }),
    toPage(arg) {
      this.$router.push({ query: { ...this.$route.query, page: arg } })
    },
    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
      if (bytes === 0) return "n/a"
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getFirstFulfilled(fields) {
      let lang = this.$i18n.locale
      if (!fields) return {}
      if (fields[lang]) {
        return {
          text: fields[lang],
          lang: lang
        }
      } else {
        const lang = Object.keys(fields).find((l) => fields[l])
        if (!lang) {
          return {}
        }
        return {
          text: fields[lang],
          lang: lang
        }
      }
    },
    async fetchData() {
      this.loading = true
      try {
        await this.fetch({
          page: +this.$route.query.page || 1,
          limit: +this.$route.query.per_page || 10
        })

        this.cacheData = this.list.slice()
      } catch (error) {
        console.log("fetchData", error)
      }
      this.loading = false
    },
    // async fetchData() {
    //     this.loading = true;

    //     try {
    //         // this.postList = await this.$store.dispatch(
    //         //   "category/posts",
    //         //   this.$route.params.cat_id
    //         // );
    //         const { data } = await this.$store.dispatch(
    //             "googleforms/fetch"
    //         );
    //         console.log(data);
    //         this.listProps["googleforms"] = data.results || [];
    //         // this.$set(this, "listProps", {
    //         //   ...data,
    //         //   googleforms:
    //         //     data.results &&
    //         //     data.results.map(item => ({
    //         //       ...item,
    //         //       title: {
    //         //         ...((item && item.title && JSON.parse(item.title)) || {})
    //         //       }
    //         //     }))
    //         // });
    //     } catch (e) {
    //         console.log(e);
    //     }

    //     this.loading = false;
    // },
    async removeItem(item) {
      try {
        const res = await this.deleteItemAction(item.id)
        if (res) {
          this.$message.success("Удаленно!")
        }
        console.log(res)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
